















import { Component, Prop, Emit, Vue } from "vue-property-decorator";
@Component
export default class TextAreaComponent extends Vue {
  @Prop({
    default: 100
  })
  public maxLength!: number;
  @Prop({
    default: "38px"
  })
  public height!: string;
  @Prop({
    default: "100%"
  })
  public width!: string;
  @Prop({
    default: ""
  })
  placeholder!: string;

  @Prop({
    default: ""
  })
  value!: string;

  @Emit()
  change(value: string) {
    return value;
  }

  get internalValue(): string {
    return this.value;
  }

  set internalValue(value: string) {
    this.change(value);
  }

  get letterCount() {
    return this.internalValue.length;
  }
}
